/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	methods: {
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				return this.performAction(
					this.prepareAction(baseActionKey)
				);
			}

			return utils.promise.reject();
		},
		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();

			if(this.actions[baseActionKey] && nodeData.id){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData.id)
				);
			}

			return utils.promise.reject();
		},
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			return this.performDecision(
				'confirm',
				{
					component:  this,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					if(context.scope.component.actions[baseActionKey]){
						var nodeIndex   = context.scope.component.getSelectedNodeIndex();
						var nodeData    = context.scope.component.getSelectedNodeData();
						context.scope.component.deselectActiveNode();
						context.scope.component.setClosestNodeAsReady(nodeIndex);

						if(nodeData.id){
							var changeFound;
							var deletionIDs = {};
							var performActions = [];
							deletionIDs[nodeIndex] = nodeData.id;

							do {
								changeFound = false;

								context.scope.component.getFilteredNodes(function(node) {
									return deletionIDs[node.entry.parent];
								}, function(node){
									if(!deletionIDs[node.entry.id]){
										changeFound = true;
										deletionIDs[node.entry.id] = node.nodeData.id
									}
								});
							} while(changeFound);

							utils.forEach(deletionIDs, function(privilegeID){
								performActions.push(context.scope.component.performAction(
									context.scope.component.prepareAction(baseActionKey, privilegeID)
								));
							});

							return utils.promise.performAll(context.scope.component, performActions).then(function(response){
								context.scope.component.refreshTrees();
								return response;
							});
						}
					}
				}

				return utils.promise.reject();
			});
		},

		sanitizeResources: function(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Privileges...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var index;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();

				var elements = {};
				var privilege;
				var counter = 0;
				utils.forEach(this.resourceData.data, function (privilegeData) {
					if(privilegeData.attributes){
						privilege = privilegeData.attributes;
						privilege.index = self.transformIDToIndex(privilege.id, 'privilege', 0, counter);
						elements[privilege.code] = privilege;
						counter++
					}
				});

				utils.forEach(elements, function (privilege, privilegeCode) {
					resources.initialized = true;

					var codeParts = privilegeCode.split(':');
					var parent = '#';
					if(codeParts.length > 1){
						for(var i = codeParts.length; i > 1; i--){
							codeParts.pop();
							if(elements[codeParts.join(':')]){
								parent = elements[codeParts.join(':')].index;
								break;
							}
						}
					}

					tree.push({
						id: privilege.index,
						parent: parent,
						text: privilege.code,
						type: 'privilege',
						state: {
							opened: false,
							disabled: false,
							selected: false
						},
						li_attr: {},
						a_attr: {}
					});
					nodes[privilege.index] = privilege;
				});

				this.resourceData = resources;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
							if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_privilegePropertiesForm')){
								await modalContentComponent.submit()
                                await options.decisionComponent.hide()
                                if(this.hasClass('templates_privilegeTrees_selectPrivilegeTrees')){
                                    this.refreshTrees()
                                }
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_PrivilegePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_privilegePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'privilege';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
